import { render, staticRenderFns } from "./equips.vue?vue&type=template&id=c28af298"
import script from "./equips.vue?vue&type=script&lang=js"
export * from "./equips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports